// extracted by mini-css-extract-plugin
module.exports = {"label":"inputs_label__JIiDH","textarea":"inputs_textarea___tIBU","input":"inputs_input__zUk_k","checkbox":"inputs_checkbox__sYjdT","slider":"inputs_slider__bnn2p"};